import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import AppContainer from "./views/AppContainer.vue";
import Categories from "./views/Categories.vue";
import Pets from "./views/Pets.vue";
import Ingredients from "./views/Ingredients.vue";
import Receipts from "./views/Receipts.vue";
import ReceiptProduction from "./views/ReceiptProduction.vue";
import Suppliers from "./views/Suppliers.vue";
import Supplies from "./views/Supply";
import Orders from "./views/Order";
import Deliveries from "./views/Delivery";
import Customers from "./views/Customer";
import Packings from "./views/Packing";
import Stock from "./views/Stock";
import PositiveReport from "./views/PositiveReport";
import Users from "./views/Users";
import AuthService from "./services/AuthService";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      beforeEnter: (to, from, next) => {
        if (AuthService.isLoggedIn()) {
          next({ name: "app" });
        } else {
          next();
        }
      }
    },
    {
      path: "/app",
      name: "app",
      component: AppContainer,
      redirect: { name: "Orders" },
      beforeEnter: (to, from, next) => {
        if (!AuthService.isLoggedIn()) {
          next({ name: "login" });
        } else {
          next();
        }
      },
      children: [
        {
          name: "Categories",
          component: Categories,
          path: "categories"
        },{
          name: "Stock",
          component: Stock,
          path: "stock"
        },
        {
          name: "Ingredients",
          component: Ingredients,
          path: "ingredients"
        },
        {
          name: "Receipt",
          component: Receipts,
          path: "receipts"
        },
        {
          name: "ReceiptProduction",
          component: ReceiptProduction,
          path: "production"
        },
        {
          name: "Suppliers",
          component: Suppliers,
          path: "suppliers"
        },
        {
          name: "Packings",
          component: Packings,
          path: "packings"
        },
        {
          name: "Customers",
          component: Customers,
          path: "customers"
        },
        {
          name: "Supplies",
          component: Supplies,
          path: "supplies"
        },
        {
          name: "Pets",
          component: Pets,
          path: "pets"
        },
        {
          name: "Deliveries",
          component: Deliveries,
          path: "deliveries"
        },
        {
          name: "Orders",
          component: Orders,
          path: "orders"
        },
        {
          name: "PositiveReport",
          component: PositiveReport,
          path: "positiveReport"
        },
        {
          name: "Users",
          component: Users,
          path: "users"
        }
      ]
    },
    {
      path: "*",
      redirect: { name: "login" }
    }
  ]
});
